import HomeConfigurationService from 'src/services/homeConfiguration'
import { LocalStorage } from 'quasar'

const STORAGE_KEY = 'home_config'

const readFromStorage = () => {
  try {
    return LocalStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

const writeToStorage = (value) => {
  try {
    LocalStorage.set(STORAGE_KEY, value)
  } catch {/* ignore */}
}

const clearStorage = () => {
  LocalStorage.remove(STORAGE_KEY)
}

export default {
  /**
   * Returns the home configuration.
   * Priority: Pinia memory → localStorage → API
   */
  async fetch () {
    if (this.config !== null) {
      return this.config
    }

    const cached = readFromStorage()
    if (cached) {
      this.config = cached
      return cached
    }

    const config = await HomeConfigurationService.fetch()
    this.config = config
    writeToStorage(config)
    return config
  },

  /**
   * Persists the config and updates memory + localStorage.
   */
  async save (config) {
    await HomeConfigurationService.save(config)
    this.config = config
    writeToStorage(config)
  },

  /**
   * Called on logout — clears all cached config.
   */
  $reset () {
    this.config = null
    clearStorage()
  }
}
